export const UPDATE = "interactions/UPDATE";
export const APPEND = "interactions/APPEND";
export const PREPEND = "interactions/PREPEND";
export const UPDATE_ONE = "interactions/UPDATE_ONE";
export const DESTROY = "interactions/DESTROY";
export const LOADING = "interactions/LOADING";
